import React from 'react';
import { Admin, Resource } from 'react-admin';
import { dataProvider } from './dataProvider';
import { authProvider } from './authProvider';
import { UserList, UserCreate, UserEdit, UserShow } from './resources/users';
import { WorkshopList, WorkshopEdit, WorkshopShow } from './resources/workshops';
import { BookingList, BookingEdit, BookingShow } from './resources/bookings';
import { CarList, CarEdit, CarShow } from './resources/cars';
import { ServiceList } from './resources/services';
import {
  ServiceTemplateList,
  ServiceTemplateCreate,
  ServiceTemplateEdit,
} from './resources/serviceTemplates';
import { Dashboard } from './Dashboard';
import { AdminLoginPage } from './AdminLoginPage';

function App() {
  return (
    <Admin
      dataProvider={dataProvider}
      authProvider={authProvider}
      dashboard={Dashboard}
      title="Workshop Booking Admin"
      requireAuth
      loginPage={AdminLoginPage}
    >
      <Resource
        name="users"
        list={UserList}
        create={UserCreate}
        edit={UserEdit}
        show={UserShow}
        recordRepresentation="name"
      />
      <Resource
        name="workshops"
        list={WorkshopList}
        edit={WorkshopEdit}
        show={WorkshopShow}
        recordRepresentation="name"
      />
      <Resource
        name="bookings"
        list={BookingList}
        edit={BookingEdit}
        show={BookingShow}
        recordRepresentation={(record) => `Booking #${record.id}`}
      />
      <Resource
        name="cars"
        list={CarList}
        edit={CarEdit}
        show={CarShow}
        recordRepresentation={(record) => `${record.manufacturer} ${record.model}`}
      />
      <Resource name="services" list={ServiceList} />
      <Resource
        name="serviceTemplates"
        options={{ label: 'Service Templates' }}
        list={ServiceTemplateList}
        create={ServiceTemplateCreate}
        edit={ServiceTemplateEdit}
        recordRepresentation="name"
      />
    </Admin>
  );
}

export default App;
